var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPositiveSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0DBF8D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2222,
    cy: 14.2222,
    r: 2.22222,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7779,
    cy: 14.2222,
    r: 2.22222,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5311 21.1406C25.3225 21.0141 25.0828 20.9482 24.8388 20.9502C24.5955 20.9455 24.3556 21.0076 24.1451 21.1297C23.9346 21.2517 23.7615 21.4291 23.6446 21.6425C23.0348 22.6953 22.159 23.5693 21.1049 24.177C20.0508 24.7846 18.8555 25.1044 17.6388 25.1044C16.4221 25.1044 15.2269 24.7846 14.1728 24.177C13.1187 23.5693 12.2428 22.6953 11.6331 21.6425C11.5505 21.4703 11.4332 21.3171 11.2886 21.1924C11.1439 21.0678 10.9751 20.9744 10.7926 20.9181C10.6101 20.8619 10.418 20.844 10.2283 20.8655C10.0386 20.8871 9.85538 20.9476 9.69019 21.0434C9.525 21.1392 9.3814 21.268 9.26842 21.422C9.15544 21.5759 9.07551 21.7515 9.03366 21.9378C8.99182 22.1241 8.98895 22.3171 9.02525 22.5045C9.06155 22.692 9.13623 22.8699 9.24459 23.0271C10.0952 24.5007 11.3188 25.7245 12.7923 26.5753C14.2658 27.4261 15.9373 27.874 17.6388 27.874C19.3403 27.874 21.0119 27.4261 22.4854 26.5753C23.9589 25.7245 25.1824 24.5007 26.033 23.0271C26.2155 22.7101 26.2652 22.3338 26.1711 21.9803C26.0771 21.6269 25.847 21.325 25.5311 21.1406Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveSmile);
export default __webpack_public_path__ + "static/media/positive-smile.48a729e4fa11c5d89f38ec84b6b0785e.svg";
export { ForwardRef as ReactComponent };